import { render, staticRenderFns } from "./Crumb.vue?vue&type=template&id=2ab74e30&"
import script from "./Crumb.vue?vue&type=script&lang=ts&"
export * from "./Crumb.vue?vue&type=script&lang=ts&"
import style0 from "./Crumb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports